import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { LimitRulesType } from 'src/app/@core/constants';
import { Customer } from 'src/app/models/customer';
import { JobInfo } from 'src/app/models/customer-job-info';
import { Param } from 'src/app/models/param';
import { PreApproveCustomerParams } from 'src/app/models/params/preApprove-customer-params';
import { PreApprovalChangeEvent } from 'src/app/models/preApprovalChangeEvent';
import { CustomerTableModel } from 'src/app/models/table-models/customer-table';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { CreditService } from 'src/app/services/credit.service';
import { CustomerService } from 'src/app/services/customer.service';
import { OnbaseService } from 'src/app/services/onbase.service';
import { CustomerUpdateJobInfoRequest } from './../../../../models/requests/customer-update-jobInfo-request';

@Component({
  selector: 'app-customer-pre-approval-form',
  templateUrl: './customer-pre-approval-form.component.html',
  styleUrls: ['./customer-pre-approval-form.component.sass'],
})
export class CustomerPreApprovalFormComponent implements OnInit {
  @Input() currentCustomer: Customer = new Customer();
  @Input() preApprovalForm: FormGroup = new FormGroup({
    homeType: new FormControl(''),
    ownVehicle: new FormControl(''),
    workSeniority: new FormControl('')
  });
  @Input() homeTypes: Array<Param> = new Array();

  @Output() preApprovalChange: EventEmitter<PreApprovalChangeEvent> =
    new EventEmitter<PreApprovalChangeEvent>();

  constructor(
    private configurationService: ConfigurationService,
    private authenticationService: AuthService,
    private customerService: CustomerService,
    private datePipe: DatePipe,
    private toastrService: ToastrService,
    private onbaseService: OnbaseService,
    private creditService: CreditService
  ) {
    this.homeTypes = new Array();
  }

  ngOnInit(): void { }

  async handlePreApproveClick(sellerCode: string, productCode: string): Promise<void> {
    if (this.preApprovalForm.touched && this.preApprovalForm.valid) {
      await this.updateJobCustomerInfo();
      await this.preApproveCustomer(sellerCode, productCode);
      this.creditService.setPreApprove({
        creditPlan: undefined,
        isCreditRequestCreated: false,
        preApproveCode: '',
        preApproveAmount: 0
      });
    }
  }

  private async updateJobCustomerInfo(): Promise<void> {
    const request = this.buildUpdateJobInfoRequestModel();
    const response = await this.customerService
      .updateJobInfoCustomer(this.currentCustomer.code, request)
      .toPromise();
    console.log(response);
  }

  private buildUpdateJobInfoRequestModel(): CustomerUpdateJobInfoRequest {
    const updateJoInfoRequestModel: CustomerUpdateJobInfoRequest =
      new CustomerUpdateJobInfoRequest();

    updateJoInfoRequestModel.countryId = this.currentCustomer.mainPersonalInfo
      ?.nationality
      ? this.currentCustomer.mainPersonalInfo?.nationality
      : '';

    updateJoInfoRequestModel.houseType = this.preApprovalForm.value.homeType;

    updateJoInfoRequestModel.ownCar = this.preApprovalForm.value.ownVehicle;
    updateJoInfoRequestModel.personality = this.currentCustomer.mainPersonalInfo
      ?.personality
      ? this.currentCustomer.mainPersonalInfo?.personality
      : '';
    const currentCustomerJobInfo: JobInfo = new JobInfo();
    const transformWorkSeniority = this.datePipe.transform(
      this.preApprovalForm.value.workSeniority,
      `YYYYMMdd`
    )
      ? this.datePipe.transform(
        this.preApprovalForm.value.workSeniority,
        `YYYYMMdd`
      )
      : '';

    currentCustomerJobInfo.admissionDate = transformWorkSeniority
      ? transformWorkSeniority
      : '';


    updateJoInfoRequestModel.jobInfoList = [currentCustomerJobInfo];

    return updateJoInfoRequestModel;
  }

  private async preApproveCustomer(sellerCode: string, productCode: string): Promise<void> {
    const { branch, salesOrg } =
      this.configurationService.readSelectedBranchAndSalesOrg();

    const preApproveParams: PreApproveCustomerParams =
      new PreApproveCustomerParams();

    preApproveParams.branchCode = branch.code;
    preApproveParams.salesOrg = salesOrg.code;
    preApproveParams.customerCode = this.currentCustomer.code;
    preApproveParams.fiscalId = this.currentCustomer.mainPersonalInfo?.fiscalId
      ? this.currentCustomer.mainPersonalInfo?.fiscalId
      : '';
    preApproveParams.fiscalIdType = this.currentCustomer.mainPersonalInfo
      ?.fiscalIdType
      ? this.currentCustomer.mainPersonalInfo?.fiscalIdType
      : '';
    preApproveParams.menu = `CUSTOMERS`;
    preApproveParams.sellerCode =
      this.authenticationService.readProfileInStorage().username;
    preApproveParams.limitRule = LimitRulesType.BURO;

    const plans = await this.onbaseService
      .readPreApproveCreditPlans(
        this.currentCustomer.code,
        branch.code,
        LimitRulesType.BURO,
        salesOrg.code,
        "",
        sellerCode
      )
      .toPromise();
    this.preApprovalChange.emit({
      plans: plans.response,
      preApprovalFormValue: this.preApprovalForm.getRawValue(),
    });

  }

  isCustomer(
    value: CustomerTableModel | User | undefined
  ): value is CustomerTableModel {
    return (value as CustomerTableModel).fullName !== undefined;
  }
}
